const awardsData = [
  { date: "2026-09", content: "Research Advancement Award, Arizona State University ($750)." },
  { date: "2026-09", content: "Peer-Reviewed Journal Paper Acceptance Award, Arizona State University ($500)." },
  { date: "2025-02", content: "Fulton Fellowship, Arizona State University." },
  { date: "2023-03", content: "Merit-Based UMSI Half Tuition Scholarship, University of Michigan ($50,000)." },
];

export default awardsData;